import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setRedirectPath } from "../../modules/actions/authActions";
import { getCart } from "../../modules/actions/cartActions";
import { addToCart } from "../../modules/actions/cartActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import { Link, withRouter } from "react-router-dom";
import { format } from "../../modules/utils"
import { getESimProducts } from "../../modules/actions/productActions";
//import { getCountries } from "../../modules/actions/countryActions";
import NotificationAlert from "react-notification-alert";
import scrollToElement from "scroll-to-element";
import {confirmAlert} from 'react-confirm-alert';
import MaskedInput from 'react-text-mask'
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';

class PurchaseESim extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            useType : "USA",
            cartType : "esim",
			country : null,
            product: {},
            orgProduct : {},

        };
        this.props.getESimProducts();
    }

    componentDidMount() {
        if (typeof this.props.location.state !== 'undefined' && typeof this.props.location.state.anchor !== 'undefined') {
            scrollToElement("#" + this.props.location.state.anchor, { offset: 0 });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(typeof this.state.country === "undefined" || this.state.country === null || Object.keys(this.state.country).length === 0) {
            console.log("nextProps", nextProps);
            if (typeof nextProps.products !== "undefined" && nextProps.products.length > 0) {
                let product = nextProps.products[0];
                /*this.setState({
                    product: {...product},
                    orgProduct: {...product}
                })*/
                this.state.product = product;
                this.state.orgProduct = product;
            }
        }
    }

    onRecurringProfileSelect(associatedProduct,recurringProfile){
		//console.log(recurringProfile, recurringProfile);
        this.props.setProduct(associatedProduct);
		this.props.setProfile(recurringProfile);
    }

    render() {
        const { product } = this.state;

        // Checking stock
        /*
        const hasStock = true;
        const hasStock = this.state.color !== null && (this.state.color !== 'BLUE' && this.state.color !== 'BLACK') ? false : true;
        const hasStock = this.state.color !== null && (this.state.color !== 'BLUE') ? false : true;
        */
        //const hasStock = this.state.color !== null && this.state.color !== 'BLACK' ? false : true;
        //const hasStock = false;
        const hasStock = true;

        return(
            <section className="BodyContainer">
                <div className="container">
                    <div className="row position-relative">

                        <NotificationAlert ref="notify"/>

                        <div className="col-md-12 services_clip pt-d-5p">
                            <div className="services_bg_pad">
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="text-left device_boxes mt-3 rounded p-4">
                                            <div id="GlobalPoint" className="services_content mt-3">

                                                {
                                                    (!hasStock) ? (
                                                        <div>
                                                            <span style={{color:"#cc0000",fontWeight:"bold"}}>OUT OF STOCK. NEW eSIM AVAILABLE IN JULY.</span><br/>
                                                            <p className="mb-1"><small>Please leave us your contact information at <a href="mailto:support@mightywifi.net">support@mightywifi.net</a>, we will contact you once we have availability again.</small></p>
                                                        </div>
                                                    ) : null
                                                }

												<div className="assoc_product">
													<div className="row">														

												{
                                                    (hasStock && typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ?
                                                        product.associated_products.map(
                                                            associated_product => (
															
															<div className="col-md-6">
																<div className="row">
																	<div style={{clear:"both",height:"15px"}}></div>
															
                                                            {
                                                                (typeof associated_product.recurring_profiles !== "undefined" && associated_product.recurring_profiles.length > 0) ? (
                                                                    associated_product.recurring_profiles.map(
                                                                        recurring_profile => (
                                                                            (recurring_profile.status === 1 && recurring_profile.price > 0) ? (

																				<div className="col-md-6" style={{clear:"both",height:"300px"}}>
																					<strong><a onClick={() => this.onRecurringProfileSelect(associated_product,recurring_profile)} style={{cursor: 'pointer'}}>{recurring_profile.description}</a></strong><br/>
																					<img onClick={() => this.onRecurringProfileSelect(associated_product,recurring_profile)} src={associated_product.image} alt={recurring_profile.name} style={{cursor: 'pointer'}} />
																				</div>                                                                        

                                                                            ) : null
                                                                        )
                                                                    )
                                                                ) : null
                                                            }
																</div>
															</div>
                                                        )
                                                    )
                                                    : null
                                                }

                                                    </div>
												</div>
											</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="desktop-view" style={{ clear: "both", height: "150px" }} />
                        <div className="mobile-view" style={{ clear: "both", height: "0px" }} />

                    </div>
                </div>
            </section>

        )
    }
}


PurchaseESim.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart,
        products: state.product.products,
        countries: state.country.countries
    };
}

export default withRouter(connect(
    mapStateToProps,
    { getESimProducts, addToCart, addFlashMessage, setRedirectPath, getCart }
)(PurchaseESim));



// WEBPACK FOOTER //
// ./src/pages/purchaseESim/PurchaseESim.js